import { Filter } from '../filter/filter.types';

export enum BreakAtElements {
  'wide' = 3,
  'medium' = 4,
}

export type FilterWrapper = {
  filters: Filter[];
};
